import React from 'react';
import { SellerSpace } from 'app/modules/contract/ui/components/desktop/seller-space/seller-space';
import './style.scss';


export const HelpPage = () => {

  return (
    <div>
      <div>
      <SellerSpace textTitle={"Besoin d'aide"} smallText={"Aide"}   />
      </div>
    </div>
  );
};
